import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';
import { GroupBase, SingleValue } from 'react-select';
import { SelectComponents } from 'react-select/dist/declarations/src/components';
import cx from 'classnames';

import { SelectOption } from '../InputSelect/components';
import styles from '../InputSelect/InputSelect.module.sass';

type InputSelectCreatableProps = {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  options: SelectOption[];
  className?: string;
  classNamePrefix?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  isError?: boolean;
  isSearchable?: boolean;
  clearable?: boolean;
  valueDefault?: SelectOption;
  components?: Partial<
    SelectComponents<SelectOption, false, GroupBase<SelectOption>>
  >;
};

const InputSelectCreatable: FC<InputSelectCreatableProps> = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    onBlur,
    options,
    className = '',
    classNamePrefix = '',
    placeholder = '',
    disabled = false,
    required = false,
    isError = false,
    isSearchable = false,
    clearable = false,
    valueDefault,
    components,
  } = props;

  const { t } = useTranslation();

  const changeHandler = (newOption: SingleValue<SelectOption>) => {
    onChange(newOption?.value || '');
  };

  const blurHandler = () => {
    onBlur();
  };

  const selectClassName = cx(className, styles.select, isError && styles.error);
  const selectPlaceholder = placeholder || t('translation.check_asset_label');

  return (
    <CreatableSelect
      id={id}
      name={name}
      className={selectClassName}
      classNamePrefix={classNamePrefix}
      options={options}
      onChange={changeHandler}
      onBlur={blurHandler}
      placeholder={selectPlaceholder}
      isDisabled={disabled}
      required={required}
      components={components}
      isSearchable={isSearchable}
      isClearable={clearable}
      defaultValue={valueDefault}
      formatCreateLabel={(inputValue) => inputValue}
    />
  );
};

export default InputSelectCreatable;
